module.exports = __webpack_public_path__ + "static/media/OrderPreparing.464f47f4.gif";